/**
 * theme.liquid
 * 
  cart.liquid to main-cart-items.liquid
  product-grid-item.liquid
  product-template.liquid
  featured-product.liquid
  collection-list.liquid

 */

class RewardsLink extends HTMLElement {
    baseUrl = 'https://account.gorewards.com.ph/';
    webLink = 'https://account.gorewards.com.ph/?utm_source=GoRewardsApp&utm_medium=Maxicare&utm_campaign=DAVI';
    imgSrc = 'https://cdn.shopify.com/s/files/1/0515/9151/2249/files/GR_Sign-up_asset_16Sep2021_720px.png?v=1633069676';


    connectedCallback() {
        this.updateSlideLink();
        this.render();   
    }

    render() {
        if ([
            'rewards',
            'ereadyadvancep',
            'ereadyadvancet',
            'primagold',
            'primasilver'
        ].includes(this.product)) {
            const link = this.webLink; // this.formatRRLink();
            let templateContent = this.buildTemplate(this.width,this.imgSrc,link);
            const shadowRoot = this.attachShadow({ mode: "open" });
            shadowRoot.appendChild(templateContent);
            this.attachEventHandlers();
        }
    }

    attachEventHandlers() {

    }

    get product() {
        return this.getAttribute('product');
    }

    set product(value) {
        this.setAttribute('product',value);
    }

    get width() {
        return this.getAttribute('width');
    }

    set width(value) {
        this.setAttribute('width',value);
    }
    static get observedAttributes() {
        return ['product','width'];
      }
    
    attributeChangedCallback(name, oldValue, newValue) {
        if (name == 'product' && this.shadowRoot) {

        }
        if (name == 'width' && this.shadowRoot) {

        }

        
    }


    buildTemplate(width,src,href) {
        const template = document.createElement('template');
        template.innerHTML = `<a class="maxi-rr-link" href="${href}" target="_blank">
            <img width="${width}" src="${src}" />
        </a>`

        return template.content;
    }

    updateSlideLink() {          
        var maxi_slide_link = document.querySelectorAll('.slide-link');
    
        maxi_slide_link.forEach(oLink => {
          
          if (oLink.getAttribute('href') == this.baseUrl) {
            oLink.setAttribute('href',this.webLink);
            oLink.setAttribute('target','_blank');      
          }
      
        });
    }

    
    formatRRLink() {
 
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|iPad)/i);
        const isAndroid = navigator.userAgent.match(/(Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
        const isHuawei = navigator.userAgent.match(/(HUAWEI)/i);
        
        if (isIOS) {
            return 'https://go.onelink.me/1zfK/22edfa9e';
        }
        if (isHuawei) {
            return  'https://go.onelink.me/1zfK/280c4fe4'; 
        }
        if (isAndroid) {
            return  'https://go.onelink.me/1zfK/6031daf8';
        }
      
        return 'https://go.onelink.me/1zfK/294d002';
      }
      
      
      


}
customElements.define('maxi-rewards-link', RewardsLink);
